import React from 'react';
import { Box, Typography, IconButton, Grid } from '@mui/material';
import WhatsAppIcon       from '@mui/icons-material/WhatsApp';
import LinkedInIcon       from '@mui/icons-material/LinkedIn';
import InstagramIcon      from '@mui/icons-material/Instagram';
import PlaceOutlinedIcon  from '@mui/icons-material/PlaceOutlined';
import PhoneOutlinedIcon  from '@mui/icons-material/PhoneOutlined';
import EmailOutlinedIcon  from '@mui/icons-material/EmailOutlined';
import { Link } from 'react-scroll';
import logo from '../assets/logo.png';
import { C, F } from '../styles/tokens';

const NAV_ITEMS = [
  { label: 'About Us',     to: 'about' },
  { label: 'Services',     to: 'services' },
  { label: 'Our Clients',  to: 'clients' },
  { label: 'Testimonials', to: 'testimonials' },
  { label: 'Contact Us',   to: 'footer' },
];

const CONTACT_INFO = [
  { icon: <PlaceOutlinedIcon sx={{ fontSize: 16 }} />, text: 'New Delhi, India' },
  { icon: <PhoneOutlinedIcon sx={{ fontSize: 16 }} />, text: '+91-9311817126' },
  { icon: <EmailOutlinedIcon sx={{ fontSize: 16 }} />, text: 'info@pracco.in' },
];

const SOCIALS = [
  { href: 'https://wa.me/message/JFOPVFN3Q4GPP1', icon: <WhatsAppIcon />,  hoverColor: C.whatsapp },
  { href: 'https://www.linkedin.com/company/pracco-corporate/?viewAsMember=true', icon: <LinkedInIcon />,  hoverColor: '#0e76a8' },
  { href: 'https://www.instagram.com/pracco.in/', icon: <InstagramIcon />, hoverColor: '#E1306C' },
];

const COL_LABEL_SX = {
  fontFamily:    F.heading,
  fontSize:      11,
  fontWeight:    700,
  letterSpacing: 2.5,
  textTransform: 'uppercase',
  color:         'rgba(255,255,255,0.3)',
  mb:            2,
};

const Footer = () => (
  <Box id="footer" sx={{ backgroundColor: C.navy }}>
    <Box sx={{ maxWidth: 1100, mx: 'auto', px: { xs: 3, md: 6 }, pt: { xs: 6, md: 8 }, pb: 5 }}>
      <Grid container spacing={5}>
        {/* Brand column */}
        <Grid item xs={12} md={5}>
          <Link to="home" smooth duration={500} offset={-70} style={{ cursor: 'pointer', display: 'inline-block' }}>
            <img src={logo} alt="Pracco" style={{ height: 36, filter: 'brightness(0) invert(1)', marginBottom: 16 }} />
          </Link>

          <Typography sx={{ fontFamily: F.body, fontSize: 14.5, color: 'rgba(255,255,255,0.55)', lineHeight: 1.75, maxWidth: 300, mb: 3 }}>
            A unified platform for professional corporate services — from company registration to GST, tax, and accounting.
          </Typography>

          <Typography sx={{ fontFamily: F.heading, fontSize: 13, fontWeight: 600, color: C.amber, fontStyle: 'italic' }}>
            "Accounting You Can Count On."
          </Typography>
        </Grid>

        {/* Quick links */}
        <Grid item xs={6} md={3}>
          <Typography sx={COL_LABEL_SX}>Quick Links</Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            {NAV_ITEMS.map(({ label, to }) => (
              <Link key={label} to={to} smooth duration={500} offset={-70}>
                <Typography
                  sx={{
                    fontFamily: F.body,
                    fontSize:   14,
                    color:      'rgba(255,255,255,0.55)',
                    cursor:     'pointer',
                    transition: 'color 0.2s',
                    '&:hover':  { color: C.amber },
                  }}
                >
                  {label}
                </Typography>
              </Link>
            ))}
          </Box>
        </Grid>

        {/* Contact */}
        <Grid item xs={6} md={4}>
          <Typography sx={COL_LABEL_SX}>Contact</Typography>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, mb: 3 }}>
            {CONTACT_INFO.map(({ icon, text }) => (
              <Box key={text} sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
                <Box sx={{ color: C.amber }}>{icon}</Box>
                <Typography sx={{ fontFamily: F.body, fontSize: 14, color: 'rgba(255,255,255,0.55)' }}>
                  {text}
                </Typography>
              </Box>
            ))}
          </Box>

          <Box sx={{ display: 'flex', gap: 0.5 }}>
            {SOCIALS.map(({ href, icon, hoverColor }) => (
              <IconButton
                key={href}
                component="a"
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={href}
                sx={{
                  color:      'rgba(255,255,255,0.4)',
                  transition: 'color 0.2s, background 0.2s',
                  '&:hover':  { color: hoverColor, background: `${hoverColor}18` },
                }}
              >
                {icon}
              </IconButton>
            ))}
          </Box>
        </Grid>
      </Grid>
    </Box>

    {/* Copyright bar */}
    <Box sx={{ borderTop: `1px solid rgba(255,255,255,0.07)`, textAlign: 'center', py: 2, backgroundColor: C.navyDeep }}>
      <Typography sx={{ fontFamily: F.body, fontSize: 13, color: 'rgba(255,255,255,0.3)' }}>
        Copyright © 2024 PRACCO. All rights reserved.
      </Typography>
    </Box>
  </Box>
);

export default Footer;
